import React, {useState, useEffect} from 'react';
import Contracts from '../../components/arts/contracts';
import { withRouter } from "react-router-dom";
import GenericUpper from '../../components/generic-upper';
import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import { store } from 'react-notifications-component';

const Contract = ({ ...props }) => {

    const [agronomo, setAgronomo] = useState('');
    const [estado, setEstado] = useState([]);
    const [filial] = useState('');
    const [crea, setCrea] = useState('');
    const [numeroArt, setNumeroArt] = useState('');
    const [apelido, setApelido] = useState('');
    const [artId, setArtId] = useState('');
    const [receitaInicial] = useState('');
    const [quantidadeContratos, setQuantidadeContratos ] = useState('');
    const [contratosUtilizados, setContratosUtilizados] = useState('');
    const [numeroOrdem] = useState('');
    const [quantidadeReceita] = useState('');
    const [produtorId, setProdutorId] = useState('');
    const [localDevolucaoId, setLocalDevolucaoId] = useState('');
    const [valorContrato, setValorContrato] = useState('');
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');

    const getAgronomo = async (artId) => {
        try {
            const response = await api.get(`/arts/${artId}`);
            if (response) {
                let artId = response.data.data.id;
                let crea = response.data.data.agro_crea_id;

                setNumeroArt(response.data.data.numero_art);
                setApelido(response.data.data.apelido || '');
                
                setCrea(crea);
                
                let estadoC = { value: response.data.data.agro_creas.estado };
                setEstado(estadoC);
                
                setArtId(artId);

                let agronomo = response.data.data.agro_creas.agro_agronomist_id;
                setAgronomo(agronomo);

                setQuantidadeContratos(response.data.data.quantidade_contratos)
                setContratosUtilizados(response.data.data.qtd_contracts)
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-621 Erro ao carregar os dados da ART - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
        }
    };

    const update = () => {
        props.history.push(`/contracts/${props.match.params.id}`);
        store.addNotification({
            title: "Sucesso!",
            message: "o Contrato foi cadastrado com sucesso!",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
    }

    useEffect(() => {
        getAgronomo(props.match.params.id)
    },[]);

    return (
        <>
            {agronomo && crea && estado.value && numeroArt && artId && (
                <>
                    <GenericUpper
                        align='center'
                        title='Cadastrar contrato'
                    ></GenericUpper>

                    <Contracts
                        estado={estado}
                        agronomo={agronomo}
                        crea={crea}
                        filial={filial}
                        numeroArt={numeroArt}
                        apelido={apelido}
                        artId={artId}
                        quantidadeReceita={quantidadeReceita}
                        receitaInicial={receitaInicial}
                        quantidadeContratos={quantidadeContratos}
                        contratosUtilizados={contratosUtilizados}
                        numeroOrdem={numeroOrdem}
                        produtorId={produtorId}
                        localDevolucaoId={localDevolucaoId}
                        valorContrato={valorContrato}
                        dataInicial={dataInicial}
                        dataFinal={dataFinal}
                        loc={props}
                        isModal={true}
                        update={() => update()}
                    />
                </>
            )} 
        </>
    )
}

export default withRouter(Contract);
